import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { showModal } from "../../../../connected-components/modal/reducer";
import { ModalType } from "../../../../shared/utils/enums";
import MainTable from "../../../../components/mainTable";
import { FormBuilder } from "../../../../components/form/FormBuilder";
import { addSupplierFormSchema } from "../../../../shared/static/forms/pharmacy/addSupplierForm";
import { getPharmacySuppliersTableColumns } from "../../../../shared/tableColumns/pharmacySuppliersColumns";
import pharmacySuppliersApi from "../../../../api/pharmacy/suppliers";
import { Supplier } from "../../../../interfaces/pharmacy";
import { store } from "../../../../redux/store";
import { hideModal } from "../../../../connected-components/modal/reducer";

const PharmacySuppliersPage = () => {
  const dispatch = useDispatch();
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadSuppliers = async () => {
    setIsLoading(true);
    const res = await pharmacySuppliersApi.getSuppliers();
    if (res.result === "success") {
      setSuppliers(res.content);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadSuppliers();
  }, []);

  const handleAddOrEdit = async (values: any, id?: string) => {
    const apiCall = id
      ? pharmacySuppliersApi.updateSupplier({ ...values, id })
      : pharmacySuppliersApi.addSupplier(values);

    const res = await apiCall;
    if (res.result === "success") {
      await loadSuppliers();
      store.dispatch(hideModal());
    }
  };

  const openAddModal = (initialValues?: Supplier) => {
    dispatch(
      showModal({
        type: ModalType.COMPONENT,
        title: initialValues ? "Edit Supplier" : "Add New Supplier",
        component: (
          <FormBuilder
            schema={addSupplierFormSchema}
            initialValues={initialValues}
            onSubmit={(values) => handleAddOrEdit(values, initialValues?.id)}
          />
        ),
      }),
    );
  };

  const handleDelete = (supplier: Supplier) => {
    dispatch(
      showModal({
        type: ModalType.QUESTION,
        title: "Delete Supplier",
        message: `Are you sure you want to delete ${supplier.name}?`,
        onConfirm: async () => {
          const res = await pharmacySuppliersApi.deleteSupplier(supplier.id);
          if (res.result === "success") {
            await loadSuppliers();
          }
        },
      }),
    );
  };

  const columns = getPharmacySuppliersTableColumns({
    onEdit: (row) => openAddModal(row),
    onDelete: handleDelete,
  });

  return (
    <div className="py-4">
      <MainTable
        columns={columns}
        data={suppliers}
        isLoading={isLoading}
        showSearch={true}
        addButtonLabel="Add New Supplier"
        onAddNewItemPress={() => openAddModal()}
      />
    </div>
  );
};

export default PharmacySuppliersPage; 